module.exports = __webpack_public_path__ + "img/transformComp.1a232fde.png";